import script from "./MobileMajorSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMajorSearch.vue?vue&type=script&setup=true&lang=js"

import "./MobileMajorSearch.vue?vue&type=style&index=0&id=2f7fac20&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7fac20"]])

export default __exports__